export default __webpack_public_path__ + "static/media/bamboo_tree.6c08c521.glb";